import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { getFileType, getFileIcon, getFileTypeColor } from '../../utils/fileHelpers';
import {
  Card,
  IconWrapper,
  Info,
  Name,
  Meta,
  Actions,
  ActionButton,
} from './DocumentCard.styles';

const DocumentCard = ({ file, onDownload }) => {
  const { t } = useTranslation();
  const fileType = getFileType(file.originalName);

  return (
    <Card>
      <IconWrapper
        bgColor={getFileTypeColor(fileType, 'background')}
        iconColor={getFileTypeColor(fileType, 'icon')}
      >
        <i className={`mdi ${getFileIcon(fileType)}`} />
      </IconWrapper>
      <Info>
        <Name title={file.name}>{file.name}</Name>
        <Meta>{file.originalName}</Meta>
      </Info>
      <Actions>
        <ActionButton onClick={() => onDownload(file)} title={t('download')}>
          <i className="mdi mdi-download" />
          {t('download')}
        </ActionButton>
      </Actions>
    </Card>
  );
};

DocumentCard.propTypes = {
  file: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
    originalName: PropTypes.string.isRequired,
  }).isRequired,
  onDownload: PropTypes.func.isRequired,
};

export default DocumentCard;
